import React from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import HighlightIcon from '@mui/icons-material/Highlight';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import useThemeStyles from '../../../hooks/useThemeStyles';

const OPTIONS = [
  { key: 'bold', label: 'Bold', icon: FormatBoldIcon },
  { key: 'italic', label: 'Italic', icon: FormatItalicIcon },
  { key: 'underline', label: 'Underline', icon: FormatUnderlinedIcon },
  { key: 'strikethrough', label: 'Strikethrough', icon: StrikethroughSIcon },
  { key: 'highlight', label: 'Highlighting', icon: HighlightIcon },
  { key: 'color', label: 'Text Color', icon: ColorLensIcon },
  {
    key: 'tab',
    label: 'Force paragraph indents (adds a tab to every paragraph)',
    icon: FormatIndentIncreaseIcon,
  },
];

const FormattingStep = ({ formattingOptions, onToggle }) => {
  const { colors } = useThemeStyles();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="body2" sx={{ color: colors.text.secondary, textAlign: 'center' }}>
        Choose which formatting to preserve from your document.
      </Typography>

      <FormGroup>
        {OPTIONS.map((option) => {
          const Icon = option.icon;
          return (
            <FormControlLabel
              key={option.key}
              control={
                <Checkbox
                  checked={Boolean(formattingOptions[option.key])}
                  onChange={() => onToggle(option.key)}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Icon fontSize="small" />
                  <span>{option.label}</span>
                </Box>
              }
            />
          );
        })}
      </FormGroup>
    </Box>
  );
};

FormattingStep.propTypes = {
  formattingOptions: PropTypes.shape({}).isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default FormattingStep;
